<template>
  <div
    class="
      tw-flex
      tw-flex-col
      tw-items-center
      tw-justify-center
      tw-gap-2
      tw-h-full
      tw-px-2
      tw-rounded-lg
      tw-border
      tw-border-dashed
      tw-border-sf-slate-lighter-2
      tw-bg-sf-slate-subtle-1
    "
    data-testid="main-chart-empty-state"
  >
    <span
      class="
        tw-flex
        tw-items-center
        tw-justify-center
        tw-w-14
        tw-h-14
        tw-rounded-full
        tw-bg-sf-slate-subtle-2
        tw-text-sf-slate-light-2
      "
    >
      <i class="fa-solid fa-chart-column tw-text-xl" aria-hidden="true" />
    </span>

    <p class="tw-m-0 tw-text-base tw-font-bold tw-text-sf-slate-dark-1">
      {{ I18n.t('report.drawer.pinned.empty_state_title') }}
    </p>
    <p
      class="
        tw-m-0
        tw-max-w-[260px]
        tw-text-center
        tw-text-sm
        tw-text-sf-slate-light-1
      "
    >
      {{ I18n.t('report.drawer.pinned.empty_state') }}
    </p>

    <SfButtonDs
      variant="primary"
      size="md"
      icon-before="plus"
      data-testid="main-chart-empty-state-create"
      @click="emit('create')"
    >
      {{ I18n.t('report.drawer.pinned.empty_state_cta') }}
    </SfButtonDs>
  </div>
</template>

<script setup lang="ts">
import SfButtonDs from '@app/shared/vue/components/sf-button/sf-button-ds.vue'
import useI18n from '@app/shared/vue/composables/use-I18n'

defineOptions({
  name: 'MainChartEmptyState',
})

// The card only renders this when the drawer is editable, so there is no
// read-only variant to handle here.
const emit = defineEmits<{ create: [] }>()

const I18n = useI18n()
</script>
